import React from "react";
import { DatePicker, DatePickerProps } from "rsuite";

import { Label } from "../Label";

const DatePickerInput = (props: DatePickerProps & { labelTitle: string; labelClassName?: string }) => {
  const { labelTitle, labelClassName, ...pickerProps } = props;

  return (
    <>
      {labelTitle ? <Label title={labelTitle} className={labelClassName} /> : null}
      <DatePicker placement="auto" {...pickerProps} />
    </>
  );
};

export default DatePickerInput;
